import Vue from 'vue'
import Router from 'vue-router'
import index from '@/pages/index/index'
import login from '@/pages/login/login.vue'
import version from '@/pages/version/version.vue'
import board from "@/pages/board/index.vue";
import clickdata from "@/pages/clickdata/clickdata.vue"
import recentUserCloud from "@/pages/RecentUserCloud/RecentUserCloud.vue";
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/board',
      name: 'board',
      component: board,
      alias: '/'
    },{
      path: '/index',
      name: 'index',
      component: index,
    }, {
      path: '/login',
      name: 'login',
      component: login
    }, {
      path: '/version',
      name: 'version',
      component: version
    },{
      path: '/recentUser',
      name: 'recentUser',
      component: recentUserCloud
    },
    {
      path:"/clickdata",
      name:"clickdata",
      component: clickdata
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js